const coursesTypeData=['pdf','video', 'docx','xlsx','pptx']

export default coursesTypeData;